import { useState } from 'react';

import DateFormat from '@core/components/display/datetime/DateFormat';
import { classNames } from '@core/utils/functions/class-names';

import WebinarCard, { WebinarCategory } from '@/components/display/cards/WebinarCard';
import { ArticleType, Event, Webinar } from '@/types/ArticleType';

interface EventsSectionProps {
    webinars: (ArticleType | Webinar | Event)[];
    category: WebinarCategory;
    className?: string;
}

const WebinarsSection = (props: EventsSectionProps) => {
    const { webinars, category, className } = props;

    const [limit, setLimit] = useState<number | undefined>(category === 'upcoming' ? 2 : 4);

    return (
        <div className="mb-10 flex flex-col justify-center items-center">
            <div className={classNames('grid grid-cols-1 lg:grid-cols-2 w-full relative gap-10 py-4', className)}>
                {webinars.slice(0, limit).map(event => (
                    <WebinarCard
                        key={event.slug}
                        title={event.title}
                        category={category}
                        imageUrl={event.imageUrl}
                        date={
                            event.type === 'webinar' ? (
                                <DateFormat
                                    dateStringOrTimestamp={event.customFields?.date || 0}
                                    format="LLLL d, yyyy | p"
                                />
                            ) : (
                                event.customFields?.text_date
                            )
                        }
                        description={event.content}
                        location={event.customFields?.location || ''}
                        sponsoredBy={event.customFields?.sponsored_by}
                        learnMoreLink={event.permalink}
                        registerLink={
                            event.customFields.registration_button_link?.url ||
                            event.customFields.header_button_1_link?.url ||
                            null
                        }
                        speakers={event.customFields?.speakers}
                    />
                ))}
            </div>
            {limit && limit < webinars.length ? (
                <button
                    onClick={() => setLimit(undefined)}
                    className="relative mt-12 flex justify-center items-center hover:text-white gap-2 px-5 py-4 text-primary hover:bg-primary hover:border-primary border bg-white"
                >
                    <p className="text-sm text-center uppercase">load more</p>
                </button>
            ) : null}
        </div>
    );
};

export default WebinarsSection;
